import React, { useState } from 'react';
import {
    useStripe,
    useElements,
    PaymentElement
} from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import stl from './CheckoutForm.module.css';
import { Preloader } from "../../atoms/Preloader";
import { logEvent } from "../../amplitude";
import getGuestId from "../../storage/getGuestId";

const CheckoutForm = ({ product }) => {
    const guestId = getGuestId();
    const stripe = useStripe();
    const elements = useElements();
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState(null); // CHANGED: тип строка

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsProcessing(true);
        setError(null);

        if (!stripe || !elements) {
            setError('Stripe.js has not loaded yet.');
            setIsProcessing(false);
            return;
        }

        // NEW: Явная валидация элементов перед подтверждением
        const submitResult = await elements.submit();
        if (submitResult?.error) {
            setError(submitResult.error.message || 'Validation error.');
            setIsProcessing(false);
            return;
        }

        try {
            logEvent("To payment pressed", {
                'Button type': 'pay',
                Amount: product?.amount,
                Fee: product?.fee, // это ваша платформа-комиссия в UI/логах; к Destination charges ок
                'Guest ID': guestId,
            });

            const result = await stripe.confirmPayment({
                elements,
                // CHANGED: добавили return_url для 3DS/редиректов
                confirmParams: {
                    return_url: `${window.location.origin}/tip-payment-confirmation`,
                },
                redirect: 'if_required',
            });

            if (result?.error) {
                setError(result.error.message || 'Payment failed.');
                setIsProcessing(false);
                return;
            }

            // Если редирект не потребовался, обрабатываем успех тут
            if (result?.paymentIntent) {
                const { id, payment_method, client_secret, status } = result.paymentIntent;
                localStorage.setItem("paymentResult", JSON.stringify({ id, payment_method, client_secret }));

                // Оставляем ваш ручной редирект с параметрами (это ок)
                const returnUrl = new URL(`${window.location.origin}/tip-payment-confirmation`);
                returnUrl.searchParams.set("payment_intent", id);
                returnUrl.searchParams.set("payment_intent_client_secret", client_secret || '');
                returnUrl.searchParams.set("redirect_status", status || '');
                window.location.href = returnUrl.toString();
            }
        } catch (err) {
            console.error('Error during payment processing:', err?.message || err);
            setError('Payment failed. Please try again.');
            setIsProcessing(false);
            // navigate('/tip-payment-confirmation'); // можно оставить, но лучше редиректить выше единообразно
        }
    };

    return (
        <form onSubmit={handleSubmit} className={stl.container}>
            <div className={stl.titleBox}>
                <p className={stl.title}>Payment Method</p>
            </div>

            <PaymentElement onReady={() => setIsProcessing(false)} />

            {error && <div className="error">{error}</div>}
            {(!stripe || !elements || isProcessing) && <Preloader />}

            <div className={stl.btnBox}>
                <button className={stl.payBtn} type="submit" disabled={isProcessing || !stripe}>
                    {isProcessing
                        ? 'Processing...'
                        : `Pay $${ Number(product?.amount)}`}
                </button>
            </div>
        </form>
    );
};

export default CheckoutForm;
